import { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';

import { useIsAudience, useIsExisting, useSaveStoreSelector } from 'pages/audience/shared/save/hooks';
import { SaveForm } from 'types/pages/audience-builder/shared/save';

export const useOrderConfiguration = () => {
  const isAudience = useIsAudience();
  const isExisting = useIsExisting();

  const saveAsMaster = useSaveStoreSelector(({ saveAsMaster }) => saveAsMaster);
  const saveAsPreBuilt = useSaveStoreSelector(({ saveAsPreBuilt }) => saveAsPreBuilt);
  const saveTo = useSaveStoreSelector(({ saveTo }) => saveTo);

  const {
    formState: { errors },
    register,
    setValue,
  } = useFormContext<SaveForm>();

  const { ref, ...props } = register('orderNumber');

  useEffect(() => {
    if (saveAsMaster || saveAsPreBuilt) {
      setValue('orderNumber', '');
    }
  }, [saveAsMaster, saveAsPreBuilt, setValue]);

  return { errors, props, readOnly: (isExisting || saveTo) && !isAudience, ref };
};
